import { addCookiePro } from "@/Modules/App/TrackersAndCookies/CookiePro";

import { isApp } from "@/Utils/Ionic";

export const addTrackersAndCookiesBanner = () => {
  if (!isApp()) {
    addCookiePro();
  }
};
